import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { fetchUserSites } from "../store/userSitesSlice"
import { fetchSites } from "../store/sitesSlice"
import { fetchChargers } from "../store/chargersSlice"
import { fetchClients } from "@/store/clientsSlice"
import { initializeScheduleColors } from "@/store/scheduleColorsSlice"
import { fetchSchedules } from "@/store/schedulesSlice"
import { fetchBookings } from "@/store/bookingsSlice"

export const Initialiser = ({}) => {
  const { user, accessToken } = useSelector((state) => state.auth)
  const schedules = useSelector((state) => state.schedules.schedules)
  const scheduleColors = useSelector((state) => state.scheduleColors.scheduleColors)
  const dispatch = useDispatch()
 
  useEffect(() => {
    if (accessToken) {
      dispatch(fetchUserSites())
      dispatch(fetchBookings())
      if (user.customer_id) {
        dispatch(fetchClients())
      }
      if (user.client_id) {
        dispatch(fetchSites())
        dispatch(fetchChargers())
        dispatch(fetchSchedules())
      }
    }
  }, [user, accessToken, dispatch])

  useEffect(() => {
    if (schedules.length) {
      const uncoloredSchedules = schedules.filter((schedule) => !scheduleColors[schedule.schedule_uid])
      if (uncoloredSchedules.length) {
        dispatch(initializeScheduleColors(uncoloredSchedules))
      }
    }
  }, [schedules, scheduleColors, dispatch])

  return null
}
